var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { rest } from 'msw';
import { notFoundError } from '@/test/utils';
import { formatApiPath } from '@/api/utils';
import { DEFAULT_MOCK_NETOPS_MODULES, DEFAULT_MOCK_LICENSES_AVAILABLE, NOM_MODULES_PATH, formatUpdateModulePath } from './modules.constants';
export function mockGetNetopsModules(server, mockModules, mockLicensesAvailable) {
    var mockResponseBody = {
        'licenses-available': mockLicensesAvailable,
        'netops-modules': mockModules,
    };
    server.use(rest.get(formatApiPath(NOM_MODULES_PATH), function (_, res, ctx) { return res(ctx.status(200), ctx.json(mockResponseBody)); }));
}
/**
 * Mock handler for test server
 */
export var mockNetopsModulesGetHandler = rest.get(formatApiPath(NOM_MODULES_PATH), function (req, res, ctx) {
    var mockResponseBody = {
        'licenses-available': DEFAULT_MOCK_LICENSES_AVAILABLE,
        'netops-modules': DEFAULT_MOCK_NETOPS_MODULES,
    };
    return res(ctx.status(200), ctx.json(mockResponseBody));
});
export var mockNetopsModulesPutHandler = rest.put(formatApiPath(formatUpdateModulePath()), function (req, res, ctx) { return __awaiter(void 0, void 0, void 0, function () {
    var requestData, moduleName, acceptableModules, alwaysActivateValue, updatedNetopsModules, mockResponseBody;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, req.json()];
            case 1:
                requestData = _c.sent();
                moduleName = req.params.moduleName;
                acceptableModules = ['dop', 'ag', 'sdi'];
                if (!acceptableModules.includes(moduleName)) {
                    return [2 /*return*/, res(ctx.status(404), ctx.json(notFoundError(req.url.pathname)))];
                }
                alwaysActivateValue = (_b = (_a = requestData.netops_modules) === null || _a === void 0 ? void 0 : _a.always_activate) !== null && _b !== void 0 ? _b : false;
                updatedNetopsModules = DEFAULT_MOCK_NETOPS_MODULES.map(function (module) {
                    if (module.id === moduleName) {
                        return __assign(__assign({}, module), { always_activate: alwaysActivateValue });
                    }
                    return module;
                });
                mockResponseBody = {
                    'licenses-available': DEFAULT_MOCK_LICENSES_AVAILABLE,
                    'netops-modules': updatedNetopsModules,
                };
                return [2 /*return*/, res(ctx.status(200), ctx.json(mockResponseBody))];
        }
    });
}); });
